import { Component, Input } from '@angular/core';

@Component({
  selector: 'payarc-form-field',
  template: `
    <div class="pa-ff" [class.pa-ff--error]="!!error">
      <label class="pa-ff__label" *ngIf="label" [attr.for]="controlId">{{ label }}<span class="pa-ff__req" *ngIf="required"> *</span></label>
      <ng-content></ng-content>
      <p class="pa-ff__hint" *ngIf="hint && !error">{{ hint }}</p>
      <p class="pa-ff__err" *ngIf="error">{{ error }}</p>
    </div>`,
  styleUrls: ['./payarc-form-field.component.css'],
  standalone: false
})
export class PayarcFormFieldComponent {
  @Input() label?: string;
  @Input() hint?: string;
  @Input() error?: string;
  @Input() required = false;
  /** id of the projected control, so the label stays associated with it for assistive tech */
  @Input() controlId?: string;
}
